import { render, staticRenderFns } from "./RedirectView.vue?vue&type=template&id=d5e2cb82&scoped=true&"
import script from "./RedirectView.vue?vue&type=script&lang=js&"
export * from "./RedirectView.vue?vue&type=script&lang=js&"
import style0 from "./RedirectView.vue?vue&type=style&index=0&id=d5e2cb82&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5e2cb82",
  null
  
)

export default component.exports